import { useEffect, useRef, useState } from 'react'
import { ArrowUpRight, Copy } from 'lucide-react'
import { INVITE_SHARE_IMAGE_PATH, invitationShareHeadline } from './share'

export function ManualInviteLink({ url }: { url: string }) {
  return <label className="invite-copy-field">长按下方链接，选择复制
    <input aria-label="专属邀请链接" readOnly value={url} onFocus={event => event.currentTarget.select()} onClick={event => event.currentTarget.select()} />
  </label>
}

export default function WechatShareGuide({ inviteUrl, inviterNickname, onClose, onReturn }: { inviteUrl: string; inviterNickname?: string; onClose: () => void; onReturn: () => void }) {
  const dialogRef = useRef<HTMLDialogElement>(null)
  const [notice, setNotice] = useState('')
  const [manualCopy, setManualCopy] = useState(false)
  useEffect(() => {
    const dialog = dialogRef.current
    dialog?.showModal()
    return () => dialog?.close()
  }, [])
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(inviteUrl)
      setNotice('邀请链接已复制，可粘贴给微信好友')
      setManualCopy(false)
    } catch {
      setNotice('自动复制不可用，请长按下方链接复制')
      setManualCopy(true)
    }
  }
  return <dialog ref={dialogRef} className="wechat-share-guide" aria-labelledby="wechat-share-title" aria-describedby="wechat-share-description" onCancel={event => { event.preventDefault(); onClose() }}>
    <div className="wechat-share-guide-content">
      <div className="wechat-share-pointer" aria-hidden="true"><ArrowUpRight /></div>
      <h2 id="wechat-share-title">点右上角 <span>···</span></h2>
      <p id="wechat-share-description">选择「发送给朋友」，把邀请送给好友</p>
      <div className="wechat-share-card"><img src={INVITE_SHARE_IMAGE_PATH} alt="86上山 Pub 店面 Logo" /><div><strong>{invitationShareHeadline(inviterNickname)}</strong><p>首次进店消费，享基础奖励与邀请加赠</p></div></div>
      <p className="wechat-share-note">好友打开链接，即可查看邀请奖励</p>
      <button className="invite-primary" onClick={copyLink}><Copy />复制邀请链接</button>
      {notice && <p className="wechat-share-notice" role="status">{notice}</p>}
      {manualCopy && <ManualInviteLink url={inviteUrl} />}
      <div className="wechat-share-secondary"><button onClick={onClose}>先看看邀请页</button><button onClick={onReturn}>返回邀请中心</button></div>
      <p className="wechat-share-help">分享朋友圈，可返回邀请中心长按保存海报</p>
    </div>
  </dialog>
}
